import React, { forwardRef } from 'react'
import Link from 'components/ui/Link/Link'

import MenuItem from './MenuItem'


const close = {
  isOpen: false,
  selectionIndex: -1,
  closingWithClick: false,
}

const MenuLink = forwardRef((props, ref) => {
  const {
    intl, _ref,
    component: Comp = Link,
    style, containerClassName,
    setState, state, index, title, customElement, dataTestId,
    onKeyDown, onClick,
    ...rest
  } = props

  const setRef = (node) => {
    _ref(node)

    if (ref) {
      ref(node)
    }
  }

  const handleClick = (event) => {
    if (onClick) {
      onClick(event)
    }

    setState(close)
  }

  const handleKeyDown = (event) => {
    if (onKeyDown) {
      onKeyDown(event)
    }

    if (event.key === 'Enter') {
      // prevent MenuItem's preventDefault from firing,
      // allowing this link to work w/ the keyboard
      event.stopPropagation()
    }
  }

  return (
    <MenuItem
      role="none"
      state={state}
      setState={setState}
      index={index}
      className={containerClassName}
    >
      {
        customElement || (
          <Comp
            role="menuitem"
            tabIndex="-1"
            title={title}
            data-selected={index === state.selectionIndex ? true : undefined}
            dataTestId={dataTestId}
            onClick={handleClick}
            onKeyDown={handleKeyDown}
            _ref={setRef}
            {...rest}
          />
        )
      }
    </MenuItem>
  )
})


export default MenuLink
